import { useQuery } from 'react-query'
import { myDateFormat } from '../Engine'

export default function ProcessVisitsList() {
    return <>
        <h1 className="text-primary pb-0">Elenco visite</h1>
        <VisitsList/>
        **Vengono visualizzate le visite terminate da non più di 30 giorni.
        <div>
        <i>Chi può accedere a questa pagina?</i><br />
        Questa pagina è accessibile a tutti gli utenti 
        con permesso <i>/process/visitsList</i>. Tale permesso è automatico 
        per gli utenti che hanno una delle seguenti qualifiche interne al dipartimento:
        'PO', 'PA', 'RIC', 'RTDb', 'RTDa', 'RTT',
        'Assegnista', 'Tecnologo', 'Titolare di contratto di ricerca', 'Titolare di incarico post-doc', 'Titolare di incarico di ricerca', 'Titolare di borsa di ricerca',
        'Dottorando in Matematica', 'Dottorando in HPSC',
        'Professore Emerito',
        'Collaboratore',
        'Personale in quiescenza',
        'PTA'.
        </div>
    </>
}

function VisitsList() {
    const { isLoading, error, data } = useQuery(['process', 'visitsList'])

    if (isLoading) {
        return "Loading..."
    }

    if (!data) {
        return "Error: " + error.message
    }

    const cellStyle={border: "1px solid", padding: "0.5em"}

    return <table style={{borderCollapse: "collapse"}}>
        <thead>
            <tr>
                <th>dal</th>
                <th>al</th>
                <th>visitatore</th>
                <th>provenienza</th>
                <th>referente</th>
                <th>ufficio</th>
            </tr>
        </thead>
        <tbody>
        {data.data.sort(sortFn).map(
            visit => <tr key={visit._id}>
                <td style={cellStyle}>{myDateFormat(visit.startDate)}</td>
                <td style={cellStyle}>{myDateFormat(visit.endDate)}</td>
                <td style={cellStyle}>{visit.person.firstName} {visit.person.lastName }</td>
                <td style={cellStyle}>{visit.affiliations.map(x => x.name).join(", ")}</td>
                <td style={cellStyle}>{visit.referencePeople.map(p => `${p.firstName} ${p.lastName}`).join(', ')}</td>
                <td style={cellStyle}>{visit.roomAssignments.map(room => roomDescription(visit,room)).join('; ')}</td>
            </tr>
        )}
        </tbody>
    </table>

    function sortFn(a, b) {
        if (a.startDate < b.startDate) return 1
        if (a.startDate > b.startDate) return -1
        return 0
    }

    function roomDescription(visit,assignment) {
        let s = assignment.room.code
        if (assignment.startDate !== visit.startDate)
            s += ` dal ${myDateFormat(assignment.startDate)}`
        if (assignment.endDate !== visit.endDate)
            s += ` al ${myDateFormat(assignment.endDate)}`
        return s
    }

}

